import { Typography } from '@material-ui/core';
import React from 'react';
import { cellDataFormatter } from 'util/TableDataFormatters';

const RelationalDisplay = ({ row, rowState, rowIndex, column, columns }) => {
  return (
    <div>
      {(column.relationalColumns || []).map((field) => {
        const currentField =
          (columns || []).find(
            (currentColumn) => currentColumn.key === field
          ) || {};
        return (
          <div
            style={{
              paddingBottom: 25,
              marginBottom: 30,
              borderBottom: '1px solid #E2E2E2',
              flex: 1,
              width: '90%',
              maxWidth: '90%',
              wordWrap: 'normal',
              paddingLeft: 5,
            }}
          >
            <Typography
              style={{
                color: '#747474',
                letterSpacing: 1.2,
                fontSize: 20,
                fontWeight: 'normal',
                marginBottom: 7.5,
              }}
            >
              {currentField.title}
            </Typography>
            <div
              style={{
                padding: '5px 5px',
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              <Typography
                style={{
                  color: '#747474',
                  letterSpacing: 1.2,
                  fontSize: 14,
                  fontWeight: 'normal',
                  marginRight: 20,
                }}
              >
                {(rowIndex || 0) + 1}.
              </Typography>
              <Typography
                style={{
                  color: '#747474',
                  letterSpacing: 1.2,
                  fontSize: 14,
                  fontWeight: 'normal',
                }}
              >
                {cellDataFormatter[currentField.columnContentType.dataType](
                  (rowState || {})[currentField.key] ||
                    ((row || {})[currentField.key] || {}).value ||
                    '',
                  currentField
                )}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RelationalDisplay;
